/**
 * Shared "{Display Name} - {SLOT}" formatter for position filter surfaces
 * (single-selection chip and the SE-4679 filter popover rows).
 * @module features/squad-planning/utils/formatPositionRoleLabel
 */

import { ROLE_DISPLAY_NAMES } from "@/features/squad-planning/constants";

/**
 * Formats a pitch role abbreviation for display, e.g. "LW" → "Left Wing - LW".
 * Falls back to the bare abbreviation when ROLE_DISPLAY_NAMES has no entry.
 * @param role - The pitch position role abbreviation
 * @returns The display label
 */
export function formatPositionRoleLabel(role: string): string {
  const displayName = ROLE_DISPLAY_NAMES[role];
  return displayName ? `${displayName} - ${role}` : role;
}
